module.exports = __webpack_public_path__ + "static/media/tony-gift.e9a7586b.png";